import React from 'react'
import { Layout, Header } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import ImageHero from 'app/theme/ImageHero'
import NavbarFixed from 'app/theme/NavbarFixed'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import heroImage from 'assets/img/wedding-catering.jpg'
import getGoogleMetaTags from './occasionSEOData'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import weddingCatering1 from 'assets/img/wedding-catering-1.jpg'
import weddingCatering2 from 'assets/img/wedding-catering-2.jpg'
import weddingCatering4 from 'assets/img/wedding-catering-4.jpg'
import weddingCatering5 from 'assets/img/wedding-catering-5.jpg'
import weddingCatering6 from 'assets/img/wedding-catering-6.jpg'
import weddingCatering7 from 'assets/img/wedding-catering-7.jpg'
import weddingCatering8 from 'assets/img/wedding-catering-8.jpg'
import weddingCatering9 from 'assets/img/wedding-catering-9.jpg'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'

export default function FoodTruckWeddingPage(props) {
  const { openModal, ...modalState } = useModalState()

  const {
    title = 'Food Truck Wedding Catering',
    description = 'We’re your culinary matchmaker. At Roaming Hunger, our technology and expertise pairs you with your perfect catering experience.',
  } = props

  const googleMetaTags = getGoogleMetaTags('wedding')

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>
          Food Truck Wedding Catering - Roaming Hunger
        </title>
        <meta
          name="description"
          content="Find the best available food trucks to cater your wedding. Get quotes and packages from food trucks and carts near you. Your friends and family will love it."
        />
        <meta
          name="og:title"
          content="Food Truck Wedding Catering"
        />
        <script type="application/ld+json">
          {googleMetaTags}
        </script>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <ImageHero
        imageUrl={heroImage}
        title={title}
        description={description}
        onButtonClick={openModal}
      />
      <NavbarFixed menuItems={navMenu} onButtonClick={openModal} />
      <Intro />
      <IntroGrid />
      <CuisineTypes baseUrl='/food-truck-catering' />
      <WhyWorkWithUs onButtonClick={openModal} />
      <WhyWorkWithUsGrid />
      <OccasionsSlider
        className="bg-white py-12"
      />
    </Layout>
  )
}

function Intro() {
  return (
    <div className="container text-center mt-12">
      <h2 className="text-navy text-4xl font-platform leading-none md:leading-normal">We Are The Food Truck Experts</h2>
      <p className="font-light text-gray-900 mt-3">
        Finding a great wedding caterer is stressful - let Roaming Hunger
        do the work so you don't have to. We'll send you the best options available to cater your wedding. Whether you want a unique
        food experience for your wedding reception, rehearsal dinner, late night
        snack or next day brunch, Roaming Hunger will help you find it.
      </p>
    </div>
  )
}

function IntroGrid() {
  return (
    <OccasionPageGrid>
      <OccasionPageGridRow
        heading="Give Us the Details"
        content="If you haven’t already, click “Get Started” to tell us about your wedding. After that, we'll send out your details to food trucks and other caterers in your area."
        image={weddingCatering1}
      />
      <OccasionPageGridRow
        heading="We Conduct the Ultimate Search"
        content="With over 18,000 food trucks, trailers, carts, and pop-up caterers all over the US and Canada, we'll find all the available options in your city. You'll get packages and pricing from each interested food truck, so you can choose the right one for your wedding."
        image={weddingCatering2}
        reverse
      />
      <OccasionPageGridRow
        heading="Book your Favorite(s)"
        content="Once you book we'll connect you with the caterer so you can make sure everything goes perfectly. You'll be able to finalize all the logistics and details, including arrival times, parking and set up."
        image={weddingCatering4}
      />
      <OccasionPageGridRow
        heading="Enjoy Your Big Day"
        content=""
        image={weddingCatering5}
        reverse
      >
        If there are any
        surprises, we’ll find a replacement caterer. We also guarantee every
        single catering with the{' '}
        <a
          className="text-blue"
          href="/food-truck-catering/roaming-hunger-guarantee/"
        >
          100% Roaming Hunger Service Guarantee.
        </a>
      </OccasionPageGridRow>
    </OccasionPageGrid>
  )
}

function WhyWorkWithUsGrid() {
  return (
    <OccasionPageGrid className="pb-10">
      <OccasionPageGridRow
        heading="Service Guarantee"
        content="Get the fantastic service you deserve on your wedding day. We have established relationships with reliable food trucks so you can book with confidence, and we hold caterer payment in escrow until after the event as an added guarantee. If something does go wrong, we will find a way to make it right."
        image={weddingCatering7}
        reverse
      />
      <OccasionPageGridRow
        heading="Peace of Mind"
        content="Be sure that your food truck is serving safely and legally at your wedding. We secure all the necessary paperwork, including contracts, W9s, certificates of insurance, and health and business permits. We are catering professionals and we expect every vendor we book to be professional too."
        image={weddingCatering8}
      />
      <OccasionPageGridRow
        heading="Flexible Service Styles"
        content="Mobile caterers comes in many shapes and sizes. Food trucks and trailers can make a great splash with your guests. Carts and pop-up caterers can fit into small spaces, backyards, or indoors. As long as you have a venue, you can find what you need."
        image={weddingCatering9}
        reverse
      />
    </OccasionPageGrid>
  )
}
const navMenu = [
  {
    title: 'Wedding Catering',
    url: '/food-truck-catering/food-truck-wedding/',
  },
  {
    title: 'Frequently Asked Questions',
    url: '/food-truck-catering/wedding-frequently-asked-questions/#submenu',
  },
]
